import { FunctionComponent } from 'react';
import { NavbarElementProps } from 'react-day-picker';
import { css } from '@emotion/react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import IconButton from 'ui/IconButton';

const calendarNavBarRoot = css`
  height: 4.8rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CalendarNavBarV5: FunctionComponent<React.PropsWithChildren<NavbarElementProps>> = ({
  labels,
  onNextClick,
  onPreviousClick,
  showNextButton,
  showPreviousButton,
}) => {
  return (
    <div css={calendarNavBarRoot}>
      <IconButton
        aria-label={labels.previousMonth}
        variant="text"
        disabled={!showPreviousButton}
        onClick={() => onPreviousClick()}
        color="secondary"
      >
        <ChevronLeftIcon fontSize="small" />
      </IconButton>
      <IconButton
        aria-label={labels.nextMonth}
        variant="text"
        disabled={!showNextButton}
        onClick={() => onNextClick()}
        color="secondary"
      >
        <ChevronRightIcon fontSize="small" />
      </IconButton>
    </div>
  );
};
